import React from "react";
import { useState } from "react";
import axios from 'axios'
import gif from './loading.gif'


let a
  

 function Help (props){
    const [load,setLoad] = useState(false) 




    function getData (){
        axios.get(`/?id=WIrbis&action=Conference/GetHelpMessage&sid=${props.sid}`).then((resp) => {
        a = resp.data

        setLoad(true)
      })
      }
      
      
      
      if (load == false) {
        return (<div className='loading'><img onLoad={getData()} src={gif} width='100' height='100'/> </div>)
      }else{
        return(
        <div className="information help" >
        
            <div className="talkbubble" dangerouslySetInnerHTML = {{__html: a}}>
               
                
            </div>
        </div>



    )
}
 }


export default Help